//@author travis

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import { DropDownItem } from "../../../pojo/DropDownItem";
import { Item } from "../../../pojo/Item";
import { S25ItemI } from "../../../pojo/S25ItemI";
import { S25Util } from "../../../util/s25-util";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-ng-contacts-editable")
@Component({
    selector: "s25-ng-contacts-editable",
    template: ` @if (init) {
        <div>
            @for (contact of modelBean; track contact; let i = $index) {
                <div class="c-margin-bottom--quarter">
                    <div class="row-flex">
                        <s25-ng-icon-button [type]="'close'" [ariaLabel]="'Delete'" (clicked)="remove(contact)" />
                        <span class="c-margin-right--single"></span>
                        <s25-item
                            [itemId]="contact.itemId"
                            [itemTypeId]="Item.Ids.Contact"
                            [itemName]="contact.itemName"
                            [includeTypeIcon]="true"
                        ></s25-item>
                    </div>
                    <span class="ng-binding notification-policy--dropdown">
                        <s25-ng-multiselect-search-criteria
                            [type]="'organizationRoles'"
                            (changed)="contact.property = $event"
                            [showResults]="true"
                            [popoverOnBody]="true"
                        />
                    </span>
                    @if (primaryContact) {
                        <span class="ngCpointer ng-scope c-margin-right--half primary-contact--radio">
                            <label for="primaryContact_{{ contact.itemId }}">
                                <input
                                    type="radio"
                                    id="primaryContact_{{ contact.itemId }}"
                                    name="primary"
                                    (click)="setPrimary(contact)"
                                    (keydown.enter)="setPrimary(contact)"
                                />Primary Contact
                            </label>
                        </span>
                    }
                </div>
            }
            <div class="c-margin-top--single">
                <span class="ngBold">Add Contact</span>
                <s25-contact-dropdown
                    (valueChange)="addContact($event)"
                    [usersOnly]="usersOnly"
                    [resetSelectedOnCleanup]="true"
                    [ariaLabel]="'Add Contact'"
                />
            </div>
        </div>
    }`,
    styles: [
        `
            .row-flex {
                display: flex;
                align-items: center;
            }

            :host ::ng-deep .s25-item-holder {
                display: flex;
                align-items: center;
                cursor: pointer !important;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})

/**
 * Component for picking a number of contacts with an additional property.
 */
export class S25ContactsEditableComponent implements OnInit {
    @Input() itemTypeId: number = 3;
    @Input() modelBean: S25ItemI[] = []; //S25ItemI + property: {itemId: itemName: }
    @Input() dropDownItems?: DropDownItem[]; //items to display in the dropdown OR some sort of code for a generic dropdown?
    @Input() dropDownLabel?: string;
    @Input() usersOnly?: boolean = true;
    @Input() primaryContact: boolean; //Show or hide primary contact chooser
    @Output() modelBeanChange = new EventEmitter<S25ItemI[]>();
    init: boolean = false;

    protected readonly Item = Item;

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        this.elementRef.nativeElement.angBridge = this;
    }

    ngOnInit(): void {
        this.modelBean = S25Util.array.forceArray(this.modelBean);
        this.init = true;
        this.cd.detectChanges();
    }

    addContact(event: any) {
        !S25Util.array.isIn(this.modelBean, "itemId", event.itemId) && this.modelBean.push(event);
        this.modelBeanChange.emit(this.modelBean);
    }

    remove(item: any) {
        S25Util.array.inplaceRemoveByProp(this.modelBean, "itemId", item.itemId);
        this.cd.detectChanges();
        this.modelBeanChange.emit(this.modelBean);
    }

    setPrimary(item: any) {
        const i = S25Util.array.findByProp(this.modelBean, "isPrimary", true);
        if (i > -1) {
            this.modelBean[i].isPrimary = false;
        }
        item.isPrimary = true;
        this.modelBeanChange.emit(this.modelBean);
    }

    setType(event: any, i: number) {}
}
